import { render, staticRenderFns } from "./stuDialog.vue?vue&type=template&id=0f10d255&scoped=true&"
import script from "./stuDialog.vue?vue&type=script&lang=js&"
export * from "./stuDialog.vue?vue&type=script&lang=js&"
import style0 from "./stuDialog.vue?vue&type=style&index=0&id=0f10d255&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f10d255",
  null
  
)

export default component.exports